import "./i18n";
import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { createBrowserRouter, RouterProvider } from "react-router";
import { routerConfig } from "./router/router.config";
import { ClerkProvider } from "@clerk/react";
import { ClerkSession } from "./components/clerk-session";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { appQueryClient } from "./api";

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
if (!publishableKey) throw new Error("Set VITE_CLERK_PUBLISHABLE_KEY to start Exibra");

const router = createBrowserRouter(routerConfig);

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <ThemeProvider
            attribute="class"
            defaultTheme="system"
            enableSystem
            storageKey="exibra-theme"
            disableTransitionOnChange
        >
            <ClerkProvider
                publishableKey={publishableKey}
                signInUrl="/auth"
                signUpUrl="/sign-up"
                signInFallbackRedirectUrl="/"
                signUpFallbackRedirectUrl="/"
                afterSignOutUrl="/auth"
            >
                <QueryClientProvider client={appQueryClient}>
                    <ClerkSession>
                        <RouterProvider router={router} />
                    </ClerkSession>
                </QueryClientProvider>
            </ClerkProvider>
        </ThemeProvider>
    </StrictMode>,
);
